import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4834c74a&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=4834c74a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4834c74a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4834c74a')) {
      api.createRecord('4834c74a', component.options)
    } else {
      api.reload('4834c74a', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=4834c74a&scoped=true&", function () {
      api.rerender('4834c74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/edu/list.vue"
export default component.exports